import "./carousel.css";
import React, { useEffect } from "react";
import NukaCarousel from "nuka-carousel";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";
import { useI18n } from "../lib/i18n/i18n_provider";

interface CarouselProps {
  children?: React.ReactNode;
  isHovered?: boolean;
  slidesToShow?: number;
}

export function Carousel(props: CarouselProps) {
  const { children, isHovered = false, slidesToShow = 1 } = props;
  const items = React.Children.count(children);
  const showNavigator = items <= slidesToShow;

  const { locale } = useI18n();

  useEffect(() => {
    if (locale.direction === "rtl") {
      const carousels = document.querySelectorAll(
        '[data-component="Carousel"]'
      );
      if (!carousels) return;

      const slider = carousels[0].children[0];
      const sliderIndexNumber = slider.children[0];
      const style = sliderIndexNumber.getAttribute("style");
      sliderIndexNumber.setAttribute(
        "style",
        `${style}; left: 0; right: -1000px`
      );
    }
  }, [locale]);

  return (
    <div
      data-component="Carousel"
      style={{
        ...styles("root"),
      }}
    >
      <NukaCarousel
        heightMode="max"
        slidesToShow={slidesToShow}
        wrapAround
        cellAlign={locale.direction === "rtl" ? "right" : "left"}
        renderCenterLeftControls={({ previousSlide }) =>
          showNavigator ? null : (
            <button
              style={styles("arrow", isHovered && "visible", "previous")}
              onClick={previousSlide}
            >
              <FaChevronLeft size={18} />
            </button>
          )
        }
        renderCenterRightControls={({ nextSlide }) =>
          showNavigator ? null : (
            <button
              style={styles("arrow", isHovered && "visible", "next")}
              onClick={nextSlide}
            >
              <FaChevronRight size={18} />
            </button>
          )
        }
      >
        {children}
      </NukaCarousel>
    </div>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
    position: "relative",
  },
  arrow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `none`,
    boxSizing: "border-box",
    borderRadius: 999,
    padding: 8,
    background: "none",
    textShadow: "none",
    boxShadow: "none",
    color: cssVariables.textColorDefault,
    margin: 0,
    backgroundColor: "white",
    cursor: "pointer",
    opacity: 0,
    transition: "opacity 0.2s",
  },
  next: {
    marginRight: 4,
  },
  previous: {
    marginLeft: 4,
  },
  visible: {
    opacity: 1,
  },
});
